module.exports = __webpack_public_path__ + "img/popup_2026_07_01.0aa06e1b.jpg";